angular.module('iw.frontyard.app')
    .service('IwocaSiteHelper', function (PublicErrorManager) {

        return {

            closeOverlay: function () {
                if (angular.isDefined(iwocaSite)
                    && angular.isFunction(iwocaSite.closeOverlay)) {
                    iwocaSite.closeOverlay();
                }
            },

            openSignupOverlay: function () {
                iwocaSite.showOverlay('.overlay.signup-step-0-modal.customer-create-account');
            },

            openLoginOverlay: function (email) {
                if (email) {
                    $('#id_email').val(email);
                }

                iwocaSite.showOverlay('.login');
            },

            redirectToInternalPage: function (path) {
                try {
                    var origin = this.getLocationOrigin();
                    window.location.href = origin + path;
                } catch (exception) {
                    PublicErrorManager.handleException(exception, 'Redirection unsupported');
                }
            },

            getLocationOrigin() {
                if (!window.location.origin) {
                    return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                }

                return window.location.origin;
            },

            applyMask: function (elementSelector, mask) {
                $(elementSelector).mask(mask, { placeholder: '' });
            },

        };

    });